// extracted by mini-css-extract-plugin
module.exports = {"social":"styles_social__1EkGP","bookmark":"styles_bookmark__KlpyK","likes":"styles_likes__3rFwh"};